import { Flex } from "@rebass/grid";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Button,
  Card,
  DisplayText,
  ESpacings,
  Icon,
  Stack,
} from "@rentiohq/web-shared/dist/components";
import { IChecklistItem } from "../ChecklistItem";
import * as S from "./IndexationCard.styled";

interface IProps {
  indexationItem: IChecklistItem;
}

export const IndexationCard = ({ indexationItem }: IProps) => {
  return (
    <Card.Section
      boxProps={{
        px: ESpacings.loose,
        py: ESpacings.base,
      }}
    >
      <DisplayText size="extraSmall">
        {getLocalizedText("property.indexation_possible.label")}
      </DisplayText>
      <S.Wrapper onClick={indexationItem.onClick}>
        <Flex justifyContent="space-between" alignItems="center">
          <Stack spacing="tight" alignment="center">
            <Icon source="currencyEuroIncrease" />
            <S.TaskTitle>
              {getLocalizedText("property.indexation_possible.description")}
            </S.TaskTitle>
          </Stack>
          <Button size="small" color="primary">
            {`${getLocalizedText("system.start")} ›`}
          </Button>
        </Flex>
      </S.Wrapper>
    </Card.Section>
  );
};
